import gql from "graphql-tag";

export const GET_INFOGO_ROOT_ORGS = gql`
    query InfoGoRootOrgs($categoryId:ID!) {
        infoGoRootOrgs(categoryId:$categoryId) {
            orgId
            relationshipId
            orgName
            createDate
            suppress
            sequence
        }
    }
`;

export const GET_INFOGO_POSITIONS = gql`
    query InfoGoPositions($orgId:ID!) {
        infoGoPositions(orgId:$orgId) {
            relationshipId
            positionId
            positionName
            isRole
            managementIndicator
            individualName
            suppress
            intranet
            sequence
        }
    }
`;

export const GET_INFOGO_ASSOCIATED_ORGS = gql`
    query InfoGoAssociatedOrgs($orgId:ID!) {
        infoGoAssociatedOrgs(orgId:$orgId) {
            relationshipId
            orgId
            orgName
            suppress
            sequence
            category {
                id
                categoryName
                type
                displayOrder
            }
        }
    }
`;

export const GET_INFOGO_HEADER_ORGS = gql`
    query InfoGoHeaderOrgs($orgId:ID!) {
        infoGoHeaderOrgs(orgId:$orgId) {
            id
            name
            presentationId
            typeName
            parentId
            suppress
            sequence
            lvl
        }
    }
`;

export const SAVE_CATEGORY_CONFIG = gql`
    mutation SaveCategoryConfig($categoryId: ID!, $input: InfoGoCategoryConfigInput) {
        saveCategoryConfig(categoryId: $categoryId, input: $input)
    }
`;

export const SAVE_ORG_CONFIG = gql`
    mutation SaveOrgConfig($orgId: ID!, $input: InfoGoOrgConfigInput) {
        saveOrgConfig(orgId: $orgId, input: $input)
    }
`;

export const GET_HEADER = gql`
    query InfoGoHeader($headerId:ID!) {
        infoGoHeader(headerId:$headerId) {
            id
            name
            nameFrench
            nameFrenchSync
            description
            descriptionFrench
            descriptionFrenchSync
        }
    }
`;

export const GET_INFOGO_PREVIEW = gql`
    query InfoGoPreview($orgId:ID!, $lang: Language, $inter: Boolean) {
        infoGoPreview(orgId: $orgId, lang: $lang, inter: $inter) {
            orgId
            orgName
            description
            parentOrgs {
                orgId
                orgName
            }
            emailList {
                emailId
                email
                emailType
            }
            phoneList {
                phoneId
                phoneType
                phoneNumber
                phoneDescription
            }
            netAddresses {
                netAddressId
                netAddress
                primary
                intranet
            }
            addresses {
                addressUsageId
                primary
                mailing
                buildingName
                buildingUnit
                street
                ruralRoute
                poBox
                postalCode
                city
                province
                country
            }
            empList {
                positionId
                name
                jobTitle
                phoneNumber
                email
            }
            childOrgs {
                orgId
	            orgName
            }
            indirectOrgs {
                orgId
                orgName
                categoryId
                categoryName
                relName
            }
        }
    }
`;

export const ADD_HEADER = gql`
    mutation AddHeader($parentId: ID!, $isParentOrg: Boolean, $input: HeaderInput) {
        addHeader(parentId: $parentId, isParentOrg: $isParentOrg, input: $input) {
            id
            name
            nameFrench
            nameFrenchSync
            description
            descriptionFrench
            descriptionFrenchSync
        }
    }
`;

export const UPDATE_HEADER = gql`
    mutation UpdateHeader($headerId: ID!, $input: HeaderInput) {
        updateHeader(headerId: $headerId, input: $input) {
            id
            name
            nameFrench
            nameFrenchSync
            description
            descriptionFrench
            descriptionFrenchSync
        }
    }
`;

export const DELETE_HEADER = gql`
    mutation DeleteHeader($headerId: ID!) {
        deleteHeader(headerId: $headerId)
    }
`;


